import { render, staticRenderFns } from "./BottomHero.vue?vue&type=template&id=00337dc0&scoped=true&"
import script from "./BottomHero.vue?vue&type=script&lang=ts&"
export * from "./BottomHero.vue?vue&type=script&lang=ts&"
import style0 from "./BottomHero.vue?vue&type=style&index=0&id=00337dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00337dc0",
  null
  
)

export default component.exports